import React, { Component } from "react";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import tableRequest from "../../models/tableRequest.js";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { connect } from "react-redux";
import { Dropdown } from "primereact/dropdown";
import TextField from "@material-ui/core/TextField";
import { DealerStockInvoiceActions } from "../../actions/DealerStockInvoiceActions.js";
import { alertActions } from "../../actions/alertActions.js";
import html2pdf from "html2pdf.js";
class DealerStockInvoice extends React.Component {
    constructor(props) {
        super(props);
        this.autoref = React.createRef();
        this.tblResponse = new tableRequest();
        this.state = {
            remarks: "",
            InvoiceNumber: "",
            globalFilter: null,
            visible: false,
            sortIcon: false,
            productLoading: true,
            dealerLoading: false,
            sortOrder: "1",
            formError: {
                dealer: "",
                InvoiceNumber: "",
                remarks: ""
            },
            DealerDDL: [],
            dealer: '',
            buttonLabel: "Submit",
            sales: [],
            scanItems: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: "No Data found",
            isScanning: false,
            scanTxt: "",
            selectedRows: [],
        };

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitFormFinal = this.submitFormFinal.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.onSort = this.onSort.bind(this);
        this.confirmSubmit = this.confirmSubmit.bind(this);
        this.ScanItem = this.ScanItem.bind(this);
        this.gatePassTemplate = this.gatePassTemplate.bind(this);
        this.handleGatePassChange = this.handleGatePassChange.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {
        this.tblResponse.SortColumn = "CreatedDt";
        setTimeout(() => {
            this.props.GetDealerInvoicing(this.tblResponse);
        }, 100);
        this.props.getDealerDDL();
    }

componentDidUpdate(prevProps) {
    if (this.props.stockItems) {
        if (prevProps.stockItems !== this.props.stockItems) {
            if (this.props.stockItems) {
                const e = this.props.stockItems;
                this.setState({
                    totalRecords: e[0]?.TotalRows || 0,
                });
            }
        }
    } else {
        if (this.state.totalRecords !== 0)
            this.setState({ totalRecords: 0, first: 0 });
    }
}

    // PAGE EVENT CALL
    onPage(event) {
        this.setState({ first: event.first, rows: event.rows });
        this.getLazyLoadingValues(event);
        this.props.GetDealerInvoicing(this.tblResponse);
    }

    // set lazy loading values
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows, first: event.first });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    }

    handleChange(event) {
        const { name, value } = event.target;
        console.log(`Field changed: ${name}, Value: ${value}`); // Log for debugging
        this.setState({ [name]: value });
    }

    // reset form text value
    formReset() {
        this.setState({
            isScanning: false,
            Tvisible: false,
            ReferenceID: "",
            InvoiceNumber: "",
            remarks: "",
            rvisible: false,
            IsActive: true,
            dealer: '',
        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = "";
        });
    }

    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }



    submitFormFinal = (event) => {

        if (event) {
            event.preventDefault(); 
        }
        if (!this.state.dealer || !this.state.InvoiceNumber || !this.state.remarks) {
            this.props.showWarn("Please fill all required fields");
            return;
        }
        // Check if scanItems exist or are not empty
        if (!this.props.scanItems || this.props.scanItems.length === 0) {
            this.props.showWarn("Scan First");
            return;
        }

        this.setState({ productLoading: true }); // Set loading to true to indicate submission process
        console.log("Current State before submit:", this.state);
        const formData = {
            dealerStockDetails: this.props.scanItems,
            remarks: this.state.remarks,
            DealerId: this.state.dealer,
            InvoiceNo: this.state.InvoiceNumber,
            CreatedBy: JSON.parse(sessionStorage.getItem("UserData")),
            UpdatedBy: JSON.parse(sessionStorage.getItem("UserData")),
        };

        console.log("FormDATA: ", formData);

        // Simulate form submission process (you can replace with an actual async call)
        setTimeout(() => {
            // Once the form is "submitted"
            this.setState({ productLoading: false });
            this.props.saveDealerInvoicing(formData);
            // Clear the form
            this.setState({ remarks: "" });
            this.formReset();

            // Focus back on the scan field if ref is available
            if (this.autoref && this.autoref.current) {
                this.autoref.current.focus();
            }
        }, 100);
    };

    // scan qr code
    ScanItem(e) {

        if (e.key === "Enter") {

            const { InvoiceNumber, dealer, remarks } = this.state;
            if (!InvoiceNumber) {
                this.props.showWarn("Enter the Invoice Number");
                return;
            }

            if (!dealer) {
                this.props.showWarn("Please Select Dealer");
                return;
            }
            if (!remarks) {
                this.props.showWarn("Enter the remarks");
                return;
            }
            this.setState({ isScanning: true });
            let qr = e.target.value;

            if (
                qr.includes("avwoods") ||
                qr.includes("localhost") ||
                qr.includes("104")
            ) {
                const splitQr = qr.split("=");
                qr = splitQr[1] === undefined ? qr : splitQr[1];
            }
            const fObj = { QrData: qr };
            this.props.GetProductByQrScan(fObj, this.props.scanItems);
            this.setState({
                scanTxt: "",
            });
            e.target.value = "";
            setTimeout(() => {
                this.setState({ isScanning: false });
            }, 9000);
        }
    }

    // delete user data
    deleteScanned(SeqNo) {
        console.log(this.props.scanItems);
        let arrayfilter = this.props.scanItems.filter((x) => x.SeqNo != SeqNo);
        this.setState({
            scanItems: arrayfilter
        });
        console.log(this.props.scanItems);
    }

    // seach table
    searchFilter(e) {
        this.props.loadingData(true);
        this.tblResponse.SearchValue = e.target.value;
        this.props.GetDealerInvoicing(this.tblResponse);
    }

    callbackFunction = (childData) => {
        this.setState({ message: childData });
    };

    // disabled checkbox
    activeTemplate(rowData, column) {
        return <input type="checkbox" disabled checked={rowData.IsActive} />;
    }


gatePassTemplate(rowData) {
    const isPrinted =
        rowData.IsGatePass === "1" ||
        rowData.IsGatePass === 1 ||
        rowData.IsGatePass === true;

    const isSelected = this.state.selectedRows.some(
        (r) => r.Id === rowData.Id
    );

    return (
        <input
            type="checkbox"
            checked={isPrinted || isSelected}
            disabled={isPrinted}                 // 👈 printed wale lock
            onChange={(e) =>
                this.handleGatePassChange(rowData, e.target.checked)
            }
        />
    );
}


handleGatePassChange = (rowData, checked) => {
    if (checked) {
        this.setState({
            selectedRows: [
                ...this.state.selectedRows.filter((r) => r.Id !== rowData.Id),
                rowData,
            ],
        });
    } else {
        this.setState({
            selectedRows: this.state.selectedRows.filter(
                (r) => r.Id !== rowData.Id
            ),
        });
    }
};

mergeInvoiceRows = (invoiceNo, rows) => {
    if (!rows.length) return null;
    const first = rows[0];

    // Saare products ikattha karo (same naam wale count ke saath)
    const countMap = {};
    rows.forEach((r) => {
        (r.ProductName || "")
            .split(",")
            .map((p) => p.trim())
            .filter((p) => p !== "")
            .forEach((p) => {
                countMap[p] = (countMap[p] || 0) + 1;
            });
    });

    // "Pu Sealer 25 ltr ×2, B-97 ×2" jaisa string
    const itemText = Object.keys(countMap)
        .map((name) => `${name} ×${countMap[name]}`)
        .join(", ");

    const totalQty = rows.reduce(
        (sum, r) => sum + Number(r.TotalQty || 0),
        0
    );

    return {
        InvoiceNo: invoiceNo,
        DealerName: first.DealerName,
        Address: first.Address,
        remarks: first.remarks,
        ItemText: itemText,
        TotalQty: totalQty,
    };
};

printSelectedGatePass = () => {
    const rows = this.state.selectedRows || [];
    if (!rows.length) {
        this.props.showWarn("Please select at least one Gate Pass");
        return;
    }

    // Group by InvoiceNo
    const grouped = {};
    rows.forEach((r) => {
        const key = r.InvoiceNo || "Unknown";
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(r);
    });

    const mergedRows = Object.keys(grouped).map((invNo) =>
        this.mergeInvoiceRows(invNo, grouped[invNo])
    );

    // 👇 print ki jagah download
    this.downloadMergedGatePass(mergedRows);

    // Save IsGatePass = 1
    Promise.all(rows.map((r) => this.props.SaveGatePass(r.Id, 1)))
        .then(() => {
            this.setState({ selectedRows: [] });
            this.props.GetDealerInvoicing(this.tblResponse);
        })
        .catch((err) => console.error("GatePass save failed:", err));
};

downloadMergedGatePass = (rows) => {
    if (!rows.length) return;

    const dealerName = rows[0].DealerName || "";
    const address = rows[0].Address || "";
    const remarks = rows[0].remarks || "";

    const d = new Date();
    const today = `${String(d.getDate()).padStart(2, "0")}/${String(
        d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;

    // Har invoice ek row
   let itemRows = "";
rows.forEach((r, i) => {
    itemRows += `
        <tr>
            <td style="border:1px solid #000;padding:6px;text-align:center;">${i + 1}</td>
            <td style="border:1px solid #000;padding:6px;text-align:center;">${r.InvoiceNo || ""}</td>
            <td style="border:1px solid #000;padding:6px;">${r.ItemText || ""}</td>
            <td style="border:1px solid #000;padding:6px;text-align:center;">${r.TotalQty || ""}</td>
            <td style="border:1px solid #000;padding:6px;">${r.remarks || ""}</td>
        </tr>`;
});



    // HTML element banado (hidden div) jise html2pdf render karega
    const container = document.createElement("div");
    container.style.width = "210mm";
    container.style.padding = "12mm";
    container.style.background = "#fff";
    container.style.fontFamily = "Arial, sans-serif";
    container.style.fontSize = "12px";
    container.style.color = "#000";

    container.innerHTML = `

     <div style="
       text-align:left;
        margin-bottom:2px;
    ">
        <img
            src="${window.location.origin}/avwoodlogo.png"
            style="
                width:70px;
                height:auto;
                display:block;
                
            "
        />
    </div>
    <div style="text-align:center;font-weight:bold;font-size:16px;
                text-decoration:underline;margin-bottom:10px;letter-spacing:1px;">
        GATE PASS
    </div>
    
    <table style="width:100%;border-collapse:collapse;">
      <tr>
        <td style="padding:3px 6px;width:20%;">Date</td>
        <td style="padding:3px 6px;width:80%;">: ${today}</td>
      </tr>
      <tr>
        <td style="padding:3px 6px;">Name of the Party</td>
        <td style="padding:3px 6px;">: ${dealerName}</td>
      </tr>
      <tr>
        <td style="padding:3px 6px;">Address</td>
        <td style="padding:3px 6px;">: ${address}</td>
      </tr>
    </table>

    <table style="width:100%;border-collapse:collapse;margin-top:10px;">
      <thead>
        <tr>
          <th style="border:1px solid #000;padding:4px;background:#f2f2f2;text-align:center;width:8%;">S.No.</th>
          <th style="border:1px solid #000;padding:4px;background:#f2f2f2;text-align:center;width:18%;">Invoice No.</th>
          <th style="border:1px solid #000;padding:4px;background:#f2f2f2;text-align:center;width:34%;">Item</th>
          <th style="border:1px solid #000;padding:4px;background:#f2f2f2;text-align:center;width:10%;">Qty</th>
          <th style="border:1px solid #000;padding:4px;background:#f2f2f2;text-align:center;width:20%;">Remarks</th>
        </tr>
      </thead>
      <tbody>${itemRows}</tbody>
    </table>

    <div style="margin-top:10px;font-size:12px;padding:6px;">
      <b>Special instructions (if any):</b> 
    </div>

    <table style="width:100%;border-collapse:collapse;margin-top:15px;">
      <tr>
        <td style="padding:25px 6px 6px 6px;text-align:center;width:25%;">Prepared By</td>
        <td style="padding:25px 6px 6px 6px;text-align:center;width:25%;">Checked By</td>
        <td style="padding:25px 6px 6px 6px;text-align:center;width:25%;">Auth Signatory</td>
      </tr>
    </table>
`;
    document.body.appendChild(container);

    // File name: GatePass_<dealer>_<date>.pdf
    const safeDealer = (dealerName || "Dealer").replace(/[^a-zA-Z0-9]/g, "_");
    const safeDate = today.replace(/\//g, "-");
    const fileName = `GatePass_${safeDealer}_${safeDate}.pdf`;

    const opt = {
        margin: 0,
        filename: fileName,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["avoid-all", "css"], avoid: ["tr", "td"] }, 
    };

    html2pdf()
        .set(opt)
        .from(container)
        .save()
        .then(() => {
            document.body.removeChild(container);
        })
        .catch((err) => {
            console.error("PDF download failed:", err);
            if (container.parentNode) document.body.removeChild(container);
        });
};
    // Sort table
    onSort(event) {
        this.props.loadingData(true);
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField =
            event.multiSortMeta[0].field === "CreatedDate"
                ? "CreatedDate"
                : event.multiSortMeta[0].field;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; 
        this.props.GetDealerInvoicing(this.tblResponse);
    }

    confirmSubmit = () => {
        confirmAlert({
            title: "Confirm to submit",
            message: "Are you sure to do this.",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.submitFormFinal(),
                },
                {
                    label: "No",
                    onClick: () => null,
                },
            ],
        });
    };

    // edit form
    actionTemplate(rowData, column) {
        const deleteFunc = () => {
            confirmAlert({
                title: "Confirm to delete",
                message: "Are you sure to do this.",
                buttons: [
                    {
                        label: "Yes",
                        onClick: () => this.props.removeItem(rowData.SeqNo),
                    },
                    {
                        label: "No",
                        onClick: () => null,
                    },
                ],
            });
        };

        return (
            <span>
                <Button
                    type="button"
                    icon="pi pi-trash"
                    onClick={deleteFunc}
                    className="p-button-danger"
                ></Button>
            </span>
        );
    }

    // create html part
    render() {
        let header = (
            <div className="row align-items-center py-2">
                {/* Header Title */}
                <div className="col-md-2">
                    <h4>Stock Invoicing</h4>
                </div>

                {/* Invoice Number Input */}
                <div className="col-md-3">
                    <div className="form-group mb-0">
                        <TextField
                            onChange={this.handleChange}
                            name="InvoiceNumber"
                            autoComplete="false"
                            value={this.state.InvoiceNumber}
                            size="small"
                            variant="outlined"
                            className="fullwidth"
                            label="Invoice Number*"
                            disabled={this.state.isScanning}
                        />
                    </div>
                </div>

                {/* Dealer Dropdown */}
                <div className="col-md-3">
                    <div className="form-group mb-0 pl-3">
                        <Dropdown
                            onChange={this.handleChange}
                            name="dealer"
                            options={this.props.DealerDDL}
                            optionLabel="label"
                            optionValue="value"
                            value={this.state.dealer}
                            filter
                            className="form-control custom-select"
                            placeholder="Select Dealer*"
                            disabled={this.state.isScanning}
                        />
                    </div>
                </div>

                <div className="col-md-2">
                    <div className="form-group mb-0">
                        <TextField
                            onChange={this.handleChange}
                            name="remarks"
                            autoComplete="false"
                            value={this.state.remarks}
                            size="small"
                            variant="outlined"
                            className="fullwidth"
                            label="Remarks*"
                            disabled={this.state.isScanning}
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group mb-0">
                        <TextField
                            name="scanTxt"
                            ref={this.autoref}
                            autoComplete="false"
                            value={this.state.scanTxt}
                            type="search"
                            onChange={(e) => this.handleChange(e)}
                            id="scanTxt"
                            onKeyDown={(e) => this.ScanItem(e)}
                            size="small"
                            variant="outlined"
                            className="fullwidth"
                            label="Scan items*"
                        />
                    </div>
                </div>
            </div>
        );

             const selectedRows = this.state.selectedRows || [];
             const printLabel = selectedRows.length
            ? `Print Gate Pass (${selectedRows.length})`
            : "Print Gate Pass";
             let header2 = (
            <div className="row">
                <div className="col-md-4 text-left">
                    <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
                    <InputText
                        type="search"
                        onInput={this.searchFilter}
                        placeholder="Global Search"
                        size="30"
                    />
                </div>
                <div className="col-md-6 text-right">
            <Button
                type="button"
                label={printLabel}         
                icon="pi pi-print"
                className="p-button-success"
                onClick={this.printSelectedGatePass}
                disabled={!selectedRows.length}
            />
        </div>
            </div>
        );

        return (
            <div className="datatable-filter-demo">
                <div className="card">
                    <div>
                        {/* <DataTable
                            responsive={true}
                            header={header}
                            emptyMessage={this.state.emptyMessage}
                            value={this.props.scanItems}
                            paginator={true}
                            currentPageReportTemplate="Total Items Added: {totalRecords}, Showing {first} to {last}"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            sortMode="multiple"
                            totalRecords={this.state.scanItems.length}
                            rows={this.state.rows}
                            className="tblAuto"
                            globalFilter={this.state.globalFilter}
                        >
                            <Column field="SeqNo" header="Visible No" sortable={true} />
                            <Column field="GroupName" header="Group Name" sortable={true} />
                            <Column
                                field="ProductName"
                                header="Product Name"
                                sortable="custom"
                            />
                            
                            <Column body={this.actionTemplate} header="Action" />
                        </DataTable> */}
                        {/* <div className="col-md-12 mapping_submitbtncol text-center mt-4 mb-4">
                            <button className="btn btn-primary"  onClick={this.confirmSubmit}>
                                Submit
                            </button>
                        </div> */}
                        <div className="col-md-12 p-0">
                            <DataTable
                                value={this.props.stockItems}
                                
                                scrollable
                                responsive={true}
                                globalFilter={this.state.globalFilter}
                                header={header2}
                                emptyMessage="No data found."
                                sortMode="multiple"
                                paginator={true}
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                                rows={this.state.rows}
                                style={{ width: "100%" }}
                                rowsPerPageOptions={[5, 10, 20, 50]}
                                totalRecords={parseInt(this.state.totalRecords)}
                                lazy={true}
                                first={this.state.first}
                                onPage={this.onPage}
                                onSort={this.onSort}
                                loading={this.props.loading}
                               >
                                {/* <Column field="Id" headerStyle={{ width: '140px' }} header="User Type" sortable={true} /> */}
                                
                                <Column
                                    field="InvoiceNo"
                                    headerStyle={{ width: "250px" }}
                                    header="Invoice Number"
                                    sortable={true}
                                />
                                <Column
                                    field="DealerName"
                                    headerStyle={{ width: "250px" }}
                                    header="User Name"
                                    sortable={true}
                                />
                                {/* <Column
                                field="UserType"
                                headerstyle={{width:"25px"}}
                                header="User Type"
                                sortable={true}
                                /> */}
                                <Column field="RoleName" headerStyle={{ width: '140px' }} header="Role" sortable={true} />
                                <Column field="Status" headerStyle={{ width: '220px' }} header="Status" sortable={true} />
                                <Column
                                    field="TotalQty"
                                    headerStyle={{ width: "250px" }}
                                    header="Total Qty"
                                    sortable={true}
                                />
                                <Column
                                    field="remarks"
                                    headerStyle={{ width: "250px" }}
                                    header="Remarks"
                                    sortable={true}
                                />
                                
                                <Column
                                    field="CreatedDt"
                                    headerStyle={{ width: "250px" }}
                                    header="Created Date"
                                    sortable={true}
                                />
                                <Column
                                 field="IsGatePass"
                                  header="Gate Pass"
                                  headerStyle={{ width: "150px" }}
                                  body={this.gatePassTemplate}
                                  sortable={true}
                                 />
                            </DataTable>
                        
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    console.log("DDL: ", state.DealerStock.dealerddl),
        console.log("scannedItems: ", state.DealerStock?.scanneditems)
    console.log("Get Invoicing: ", state.DealerStock?.stockItems)
    return {
        DealerDDL: state.DealerStock.dealerddl,
        scanItems: state.DealerStock?.scanneditems,
        stockItems: state.DealerStock?.stockItems,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDealerDDL: () => {
            dispatch(DealerStockInvoiceActions.getDealerDDL());
        },
        GetProductByQrScan: (QrData, scanneditems) => {
            dispatch(
                DealerStockInvoiceActions.getProductByQrScan(QrData, scanneditems));
        },
        removeItem: (data) => dispatch(DealerStockInvoiceActions.removeItem(data)),
        showWarn: (message) => dispatch(alertActions.warning(message)),
        saveDealerInvoicing: (formData) =>
            dispatch(DealerStockInvoiceActions.saveDealerInvoicing(formData)),
        GetDealerInvoicing: (tblObj) =>
            dispatch(DealerStockInvoiceActions.GetDealerInvoicing(tblObj)),
        loadingData: (isLoding) => dispatch(DealerStockInvoiceActions.loadingData(isLoding)),
         SaveGatePass: (Id, IsGatePass) =>
              dispatch(DealerStockInvoiceActions.SaveGatePass(Id, IsGatePass)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DealerStockInvoice);